import React from 'react';
import PropTypes from 'prop-types';
import { Alert as BootstrapAlert } from "reactstrap";

import "./Alert.css"

const ICONS = {
  info: "fas fa-info-circle",
  warning: "fas fa-exclamation-triangle",
  danger: "fas fa-exclamation-circle",
  success: "fas fa-check-circle",
};

/**
 * Page-level banner.
 *
 * The design system had no banner at all, so views that needed to explain a state
 * either hid the block or said nothing. Wraps reactstrap's Alert in the Argon look,
 * the same way Badge does.
 */
export const Alert = ({ variant = "info", title, icon, className, children, ...rest }) => {
  const iconClass = icon === null ? null : (icon || ICONS[variant] || ICONS.info);

  return (
    <BootstrapAlert
      color={variant}
      className={`sk-alert sk-alert--${variant} ${className || ""}`}
      {...rest}
    >
      <div className="sk-alert__body">
        {iconClass && <i className={`sk-alert__icon ${iconClass}`} aria-hidden="true" />}
        <div>
          {title && <span className="sk-alert__title">{title}</span>}
          {children && <span className="sk-alert__text">{children}</span>}
        </div>
      </div>
    </BootstrapAlert>
  );
};

Alert.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'danger', 'success']),
  title: PropTypes.node,
  /** Font Awesome class, or null to drop the icon. */
  icon: PropTypes.string,
  children: PropTypes.node,
};

export default Alert;
